import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";
import { forwardRef } from "react";

const PromotionBannerCloseIcon: React.FC<SvgIconProps> = forwardRef(({...props}, ref) => {
  return(
    <SvgIcon {...props} viewBox="0 0 20 20" innerRef={ref}>
      <g>
        <rect width="20" height="20" fill="#1a1a1a"/>
        <path d="M11084.777,4287.192l-2.121-2.121-2.122,2.121a1,1,0,0,1-1.413-1.414l2.121-2.122-2.121-2.122a1,1,0,0,1,1.413-1.413l2.122,2.121,2.121-2.121a1,1,0,0,1,1.416,1.413l-2.122,2.122,2.122,2.122a1,1,0,0,1-1.416,1.414Z" transform="translate(-11072.648 -4273.648)" fill="currentColor" />
      </g>
    </SvgIcon>
  )
});

export default PromotionBannerCloseIcon;